import { parse, stringify } from 'query-string';

/**
 * @param {string} url
 * @param {Object<string, string>} appendix
 * @return {string}
 */
export default function appendQueryString(url, appendix) {
  if (typeof url !== 'string') {
    return '';
  }

  const [urlWithoutHash='', hash] = url.split('#');
  const [urlWithoutHashAndQueryString = '', queryString=''] = urlWithoutHash.split('?');

  const mergedQueryString = stringify({
    ...parse(queryString),
    ...appendix,
  });

  let result = urlWithoutHashAndQueryString;

  if (mergedQueryString) result = `${result}?${mergedQueryString}`;
  if (hash) result = `${result}#${hash}`;

  return result
}
